import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient";
import pivoIcon from "../../Assets/Icons/pivo.png";
import vodaIcon from "../../Assets/Icons/voda.png";
import sokIcon from "../../Assets/Icons/sok.png";
import vinoIcon from "../../Assets/Icons/vino.png";
import zesticaIcon from "../../Assets/Icons/zestica.png";
import kavaIcon from "../../Assets/Icons/kava.png";
import defaultIcon from "../../Assets/Icons/default.png";
import LoaderBox from "../HomePage/LoaderBox";

const categoryIcons = {
  pivo: pivoIcon,
  voda: vodaIcon,
  sok: sokIcon,
  vino: vinoIcon,
  zestica: zesticaIcon,
  kava: kavaIcon,
};

const AdminInventory = ({ onBack }) => {
  const [items, setItems] = useState([]);
  const [cart, setCart] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [notify, setNotify] = useState({ show: false, msg: "" });

  useEffect(() => {
    fetchInventory();
  }, []);

  const triggerNotify = (msg, type = "error") => {
    setNotify({ show: true, msg, type });
    setTimeout(() => setNotify({ show: false, msg: "", type: "error" }), 3000);
  };

  const fetchInventory = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from("inventory")
      .select("*")
      .order("id", { ascending: true });

    if (error) {
      console.error("Greška pri dohvaćanju:", error.message);
    } else {
      setItems(data || []);
    }
    setLoading(false);
  };

  const calculateTotal = () => {
    return Object.entries(cart)
      .reduce((acc, [id, qty]) => {
        const item = items.find((i) => i.id === parseInt(id));
        return acc + (item ? item.price * qty : 0);
      }, 0)
      .toFixed(2);
  };

  const addToCart = (id) => {
    const item = items.find((i) => i.id === id);
    const stockLeft = item.total_stock - item.sold_count;
    const inCart = cart[id] || 0;

    // Ako je u košarici već sve što imamo na stanju, stopiraj
    if (inCart >= stockLeft) {
      triggerNotify(`Nema više na zalihi! (Max: ${stockLeft})`);
      return;
    }

    setCart((prev) => ({
      ...prev,
      [id]: inCart + 1,
    }));
  };

  const updateCartQty = (id, delta, e) => {
    e.stopPropagation();
    const item = items.find((i) => i.id === parseInt(id));
    const stockLeft = item.total_stock - item.sold_count;
    const currentQty = cart[id] || 0;

    setCart((prev) => {
      const newVal = currentQty + delta;

      // Provjera gornje granice (zaliha)
      if (newVal > stockLeft) {
        triggerNotify("Nema dovoljno na zalihi!");
        return prev;
      }

      // Provjera donje granice (brisanje iz košarice)
      if (newVal <= 0) {
        const { [id]: _, ...rest } = prev;
        return rest;
      }

      return { ...prev, [id]: newVal };
    });
  };

  const handleCheckout = async () => {
    if (Object.keys(cart).length === 0) return;
    setSaving(true);

    try {
      for (const [id, qty] of Object.entries(cart)) {
        const item = items.find((i) => i.id === parseInt(id));
        await supabase
          .from("inventory")
          .update({ sold_count: item.sold_count + qty })
          .eq("id", id);
      }

      setCart({});
      await fetchInventory();

      // OVDJE POZIVAMO MODAL NA VRHU (Zelena boja)
      triggerNotify("Prodaja uspješno spremljena!", "success");
    } catch (err) {
      triggerNotify("Greška pri spremanju!", "error");
    } finally {
      setSaving(false);
    }
  };

  const getIcon = (category) => {
    // Dohvati sliku iz objekta, ako ne postoji uzmi default
    const iconSrc = categoryIcons[category] || defaultIcon;

    return (
      <img
        src={iconSrc}
        alt={category}
        style={{ width: "40px", height: "40px", objectFit: "contain" }}
      />
    );
  };

  if (loading)
    return (
      <>
        {" "}
        <LoaderBox text="Učitavanje podataka..." />
      </>
    );

  return (
    <div className="inventory-wrapper">
      <div
        className={`custom-alert-modal ${notify.show ? "show" : ""} ${notify.type}`}
      >
        <i
          className={`fi ${notify.type === "success" ? "fi-rs-check" : "fi-rs-exclamation"}`}
        ></i>
        <span>{notify.msg}</span>
      </div>
      <div className="inventory-header">
        <button className="back-btn-minimal" onClick={onBack}>
          <i className="fi fi-rs-arrow-left"></i> Idi natrag
        </button>
        <h2>ŠANK</h2>
        <div className="status-dot"></div>
      </div>

      <div className="inventory-grid">
        {items.map((item) => {
          // 1. Izračunaj preostalo stanje
          const stockLeft = item.total_stock - item.sold_count;

          // 2. Odredi klasu za border ovisno o stanju
          let statusClass = "";
          if (stockLeft <= 0) {
            statusClass = "out-of-stock";
          } else if (stockLeft <= 5) {
            statusClass = "low-stock";
          }

          return (
            <div
              key={item.id}
              // OVDJE DODAJEMO DINAMIČKU KLASU
              className={`item-card ${statusClass}`}
              onClick={() => {
                if (stockLeft > 0) {
                  addToCart(item.id);
                } else {
                  triggerNotify("Artikl je rasprodan!");
                }
              }}
            >
              <span className="stock-label">
                {stockLeft <= 0 ? "NEMA" : `${stockLeft} kom`}
              </span>
              <div className="item-icon">{getIcon(item.category)}</div>
              <span className="item-name">{item.name}</span>
              <span className="item-price">{item.price.toFixed(2)}€</span>
            </div>
          );
        })}
      </div>

      {Object.keys(cart).length > 0 && (
        <div className="cart-bar">
          <div className="cart-scroll">
            {Object.entries(cart).map(([id, qty]) => {
              const item = items.find((i) => i.id === parseInt(id));
              return (
                <div key={id} className="cart-chip">
                  <span>{item.name}</span>
                  <div className="chip-btns">
                    <button onClick={(e) => updateCartQty(id, -1, e)}>-</button>
                    <strong>{qty}</strong>
                    <button onClick={(e) => updateCartQty(id, 1, e)}>+</button>
                  </div>
                </div>
              );
            })}
          </div>
          <button
            className="checkout-btn"
            onClick={handleCheckout}
            disabled={saving}
          >
            {saving ? (
              "SPREMANJE..."
            ) : (
              <div className="checkout-content">
                <span>NAPLATI:</span>
                <strong style={{ fontSize: "1.4rem" }}>
                  {calculateTotal()}€
                </strong>
              </div>
            )}
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminInventory;
